import httpService from '@Utils/httpService';

const baseUrl = 'api/tags/pipeline';

export default {
  /**
   * Get pipeline tags with typeahead search
   * @param {Object} params - Search parameters
   * @param {AbortSignal} [signal] - Optional AbortSignal for cancellation
   */
  get(params, signal = null) {
    return httpService.get({
      url: `${baseUrl}/typeHead`,
      params,
      signal,
    });
  },
  /**
   * Get pipeline tag by ID
   * @param {string} id - Tag ID
   * @param {string|null|AbortSignal} [assetId] - Facility ID, or the legacy abort signal
   * @param {AbortSignal} [signal] - Optional AbortSignal for cancellation
   */
  getById(id, assetId = null, signal = null) {
    if (assetId != null && typeof assetId !== 'string') {
      signal = assetId;
      assetId = null;
    }
    return httpService.get({
      url: `${baseUrl}/${id}`,
      params: { assetId },
      signal,
    });
  },
  update(data) {
    if (!data.id) return this.add(data);
    return httpService.put({
      url: `${baseUrl}/${data.id}`,
      data,
    });
  },
  add(data) {
    return httpService.post({
      url: baseUrl,
      data,
    });
  },
  del(id) {
    return httpService.delete({
      url: `${baseUrl}/${id}`,
    });
  },
  getDeletionImpact(ids, assetId) {
    return httpService.post({
      url: `${baseUrl}/deletionImpact`,
      data: { ids, assetId },
    });
  },
};
